const projects = [
  {
    title: "booking site",
    description: "Hotel reservations (UI)",
    image: require("../assets/images/bookingUI.png"),
    category: "all react",
    address: "https://booking-clone-alpha.vercel.app",
    code: "https://github.com/kebele",
  },
  {
    title: "wordlish",
    description: "A clone of the wordle game",
    image: require("../assets/images/wordlish.png"),
    category: "all react",
    address: "https://wordlish.vercel.app/",
    code: "https://github.com/kebele",
  },
  {
    title: "movie site",
    description: "A website about movies/tv series",
    image: require("../assets/images/moviesite.png"),
    category: "all react",
    address: "https://whatashow.vercel.app/",
    code: "https://github.com/kebele",
  },
  {
    title: "social media site",
    description: "A social media site (UI)",
    image: require("../assets/images/mui-social.png"),
    category: "all react",
    address: "https://mui-social.vercel.app/",
    code: "https://github.com/kebele",
  },
  {
    title: "covid protection web site",
    description: "A website about preventing the covid-19",
    image: require("../assets/images/covid_web.png"),
    category: "all react",
    address: "https://covid-web-eight.vercel.app/",
    code: "https://github.com/kebele",
  },
  {
    title: "kids web site",
    description: "A website about kids",
    image: require("../assets/images/kids_web.png"),
    category: "all react",
    address: "https://kidsy-web.vercel.app/",
    code: "https://github.com/kebele",
  },
  {
    title: "crypto market site",
    description: "A site about crypto coins",
    image: require("../assets/images/cryptoxic.png"),
    category: "all react",
    address: "https://r-cryptoxic.vercel.app/",
    code: "https://github.com/kebele",
  },
  {
    title: "hamburger shop site",
    description: "A website about a hamburger restaurant",
    image: require("../assets/images/hamburger_web.png"),
    category: "all react",
    address: "https://hamburger-web.vercel.app/",
    code: "https://github.com/kebele",
  },
  {
    title: "ip finder on map",
    description: "xxx ve yyyy apileri ile ip bulucu",
    image: require("../assets/images/vue-iptracker.png"),
    category: "all vue",
    address: "https://vue-ip-tracker.vercel.app/",
    code: "https://github.com/kebele/vue_ip_tracker",
  },
  {
    title: "bookshop site",
    description: "A website about a bookshop",
    image: require("../assets/images/book_web.png"),
    category: "all react",
    address: "https://book-web-seven.vercel.app",
    code: "https://github.com/kebele",
  },
  {
    title: "memory game",
    description: "memory game",
    image: require("../assets/images/memorygame.png"),
    category: "all react",
    address: "https://memgame-five.vercel.app/",
    code: "https://github.com/kebele",
  },
  {
    title: "hospital site",
    description: "A website about a hospital",
    image: require("../assets/images/hospital_web.png"),
    category: "all react",
    address: "https://hospital-web-chi.vercel.app/",
    code: "https://github.com/kebele",
  },
  {
    title: "food inc. website",
    image: require("../assets/images/foodinc.png"),
    category: "all html-css",
    description: "website about a restaurant",
    address: "https://food-inc.vercel.app/",
    code: "https://github.com/kebele/food_inc",
  },
  {
    title: "millionaire game",
    description: "Who Wants to Be a Millionaire game",
    image: require("../assets/images/millionaire.png"),
    category: "all react",
    address: "https://millionaire-tau.vercel.app/",
    code: "https://github.com/kebele/millionaire",
  },
  {
    title: "grocery site",
    description: "multi page web site (UI)",
    image: require("../assets/images/grocery_web.png"),
    category: "all react",
    address: "https://grocery-web-red.vercel.app/",
    code: "https://github.com/kebele",
  },
  {
    title: "vue kanban board",
    image: require("../assets/images/vue-kanban.png"),
    category: "all vue",
    description: "vue.js ile kanban uygulaması",
    address: "https://kanban-kohl.vercel.app/",
    code: "https://github.com/kebele/kanban",
  },
  {
    title: "travel site",
    description: "A website about a travelling",
    image: require("../assets/images/travel_web.png"),
    category: "all react",
    address: "https://travel-web-seven.vercel.app/",
    code: "https://github.com/kebele",
  },
  {
    title: "todo app",
    description: "A todo app with date and category features",
    image: require("../assets/images/todox.png"),
    category: "all react",
    address: "https://react-todox.vercel.app/",
    code: "https://github.com/kebele",
  },
  {
    title: "a portfolio site",
    description: "A website about portfolio",
    image: require("../assets/images/porfogo_web.png"),
    category: "all react",
    address: "https://porfogo.vercel.app/",
    code: "https://github.com/kebele",
  },
  {
    title: "quiz app",
    description: "A quiz app with categorized questions",
    image: require("../assets/images/quizcate.png"),
    category: "all react",
    address: "https://categoryquiz.vercel.app/",
    code: "https://github.com/kebele",
  },
  {
    title: "wavy loader",
    description: "wavy loader with css",
    image: require("../assets/images/wavy_loader.png"),
    category: "all html-css",
    address: "https://wavy-loader.vercel.app/",
    code: "https://github.com/kebele",
  },
  {
    title: "truck drive",
    description: "truck drive oyunu",
    image: require("../assets/images/js-truckdrive.png"),
    category: "all javascript",
    address: "https://2d-truck-driving.vercel.app/",
    code: "https://github.com/kebele/vue_ip_tracker",
  },
  {
    title: "todo list",
    description: "Todo list app",
    image: require("../assets/images/r-todo.png"),
    category: "all react",
    address: "https://r-tasks.vercel.app/",
    code: "https://github.com/kebele",
  },
  {
    title: "todo app",
    description: "Todo list mobile app",
    image: require("../assets/images/rntodolist.png"),
    category: "all react_native",
    address: "https://expo.dev/@kbele/rn-todolist",
    code: "https://github.com/kebele",
  },
  {
    title: "responsive cv",
    image: require("../assets/images/cv.png"),
    category: "all html-css",
    description: "responsive cv using css",
    address: "https://css-cv-three.vercel.app/",
    code: "https://github.com/kebele/css-cv",
  },
  {
    title: "chat app",
    description: "mobile chat app",
    image: require("../assets/images/r-todo.png"),
    category: "all react_native",
    address: "https://expo.dev/@kbele/rn-chat",
    code: "https://github.com/kebele",
  },
  {
    title: "animated dot menu",
    description: "dot menu with css",
    image: require("../assets/images/dot_menu.png"),
    category: "all html-css",
    address: "https://dot-menu.vercel.app/",
    code: "https://github.com/kebele",
  },
  {
    title: "admin panel",
    description: "admin panel (UI)",
    image: require("../assets/images/admin.png"),
    category: "all react",
    address: "https://r-admin.vercel.app/",
    code: "https://github.com/kebele/r-admin",
  },
  {
    title: "matrix rain",
    description: "matrix rain effect",
    image: require("../assets/images/matrix_rain.png"),
    category: "all javascript",
    address: "https://matrix-rain-alpha.vercel.app/",
    code: "https://github.com/kebele",
  },
  {
    title: "notes app",
    description: "mobile notes app",
    image: require("../assets/images/rnnotes.png"),
    category: "all react_native",
    address: "https://expo.dev/@kbele/rn-notes-async",
    code: "https://github.com/kebele",
  },
  {
    title: "ccola website",
    image: require("../assets/images/ccola_web.png"),
    category: "all html-css",
    description: "website about ccola",
    address: "https://ccola-landing.vercel.app/",
    code: "https://github.com/kebele/ccola_landing",
  },
  {
    title: "tic tac toe",
    description: "mobile tic tac toe game",
    image: require("../assets/images/rntictactoe.png"),
    category: "all react_native",
    address: "https://expo.dev/@kbele/rn-tic-tac-toe",
    code: "https://github.com/kebele/rn-tic-tac-toe",
  },
  {
    title: "3d box rotate",
    description: "3d rotating boxes via css",
    image: require("../assets/images/3dboxrotate.png"),
    category: "all html-css",
    address: "https://3d-box-rotate.vercel.app/",
    code: "https://github.com/kebele/3d_box_rotate",
  },
  {
    title: "crypto app",
    description: "mobile crypto price screen app",
    image: require("../assets/images/rncrypto.png"),
    category: "all react_native",
    address: "https://expo.dev/@kbele/rn-fetch-crypto",
    code: "https://github.com/kebele",
  },
  {
    title: "los pollos landing page",
    image: require("../assets/images/lospollos_web.png"),
    category: "all html-css",
    description: "website about los pollos hermanos :)",
    address: "https://lospollos-landing.vercel.app/",
    code: "https://github.com/kebele/lospollos_landing",
  },
  {
    title: "error page",
    description: "error page via css",
    image: require("../assets/images/errorpage.png"),
    category: "all html-css",
    address: "https://error-page-blond.vercel.app/",
    code: "https://github.com/kebele/error_page",
  },
  {
    title: "accordeon FAQ",
    image: require("../assets/images/accord_css.png"),
    category: "all html-css",
    description: "frequently asked questions component",
    address: "https://accordeon-css.vercel.app/",
    code: "https://github.com/kebele/accordeon_css",
  },
  {
    title: "masonry gallery",
    description: "html - css ile masonry gallery",
    image: require("../assets/images/masonry.png"),
    category: "all html-css",
    address: "https://masonry-html.vercel.app/",
    code: "https://github.com/kebele/masonry-html",
  },
  {
    title: "wordlish app",
    description: "a wordle mobile clone app",
    image: require("../assets/images/rnwordle.png"),
    category: "all react_native",
    address: "https://expo.dev/@kbele/wordlish",
    code: "https://github.com/kebele",
  },
  {
    title: "peps landing page",
    image: require("../assets/images/pepsi_web.png"),
    category: "all html-css",
    description: "website about peps",
    address: "https://peps-landing.vercel.app/",
    code: "https://github.com/kebele/peps_landing",
  },
  {
    title: "colorful squares",
    image: require("../assets/images/colorsquare.png"),
    category: "all html-css",
    description: "colorful rotating squares with css",
    address: "https://colorful-rotating-squares.vercel.app/",
    code: "https://github.com/kebele/colorful_rotating_squares",
  },
  {
    title: "weather app (UI)",
    description: "a weather app",
    image: require("../assets/images/rnweather.png"),
    category: "all react_native",
    address: "https://github.com/kebele/rn-weather",
    code: "https://github.com/kebele/rn-weather",
  },
  {
    title: "quote app (UI)",
    description: "a quote app with API",
    image: require("../assets/images/quotable.png"),
    category: "all react_native",
    address: "https://github.com/kebele/rn-quote-app",
    code: "https://github.com/kebele/rn-quote-app",
  },
  {
    title: "news app ",
    description: "a news app with API",
    image: require("../assets/images/news.png"),
    category: "all react_native",
    address: "https://expo.dev/@kbele/news-app",
    code: "https://github.com/kebele/rn-news",
  },

  {
    title: "the meal app",
    description: "Meal recipes site",
    image: require("../assets/images/meals.png"),
    category: "all react",
    address: "https://r-meal.vercel.app/",
    code: "https://github.com/kebele",
  },
  {
    title: "animated card hover",
    description: "card hover with css",
    image: require("../assets/images/card_hover12.png"),
    category: "all html-css",
    address: "https://card-hover-num.vercel.app/",
    code: "https://github.com/kebele",
  },
  {
    title: "blog web site ",
    image: require("../assets/images/web-2.png"),
    category: "all vue",
    description: "blog site using Vue.js",
    address: "https://blog-inky-mu.vercel.app/",
    code: "#",
  },
  {
    title: "flappy bird clone",
    image: require("../assets/images/flappy2.png"),
    category: "all javascript",
    description: "flappy bird clone",
    address: "https://flappy-2.vercel.app/",
    code: "https://github.com/kebele/flappy_2",
  },
  {
    title: "motorbike website ",
    image: require("../assets/images/harleyweb.png"),
    category: "all html-css",
    description: "responsive website UI",
    address: "https://harley-web.vercel.app/",
    code: "https://github.com/kebele/harley-web",
  },
  {
    title: "bicycle with animated scene",
    description: "bicycle with animated scene via css",
    image: require("../assets/images/bicyclescene.png"),
    category: "all html-css",
    address: "https://animated-scene.vercel.app/",
    code: "https://github.com/kebele/animated_scene",
  },
  {
    title: "travel agency website ",
    image: require("../assets/images/web-1.png"),
    category: "all vue",
    description: "travel agency website made with Vue.js",
    address: "https://befree-iota.vercel.app/",
    code: "#",
  },
  {
    title: "pomodoro clock",
    image: require("../assets/images/react-pomodoro.png"),
    category: "all react",
    description: "react.js ile pomodoro app",
    address: "https://pomodoro-dun.vercel.app/",
    code: "https://github.com/kebele/pomodoro",
  },
  // {
  //   title: "drum machine",
  //   image: require("../assets/images/react-drum.png"),
  //   category: "all react",
  //   description: "react.js ile keyboard drum app",
  //   address: "https://drum-machinex.vercel.app/",
  //   code: "https://github.com/kebele/drum_machine",
  // },
  {
    title: "random color",
    image: require("../assets/images/randomcolor.png"),
    category: "all javascript",
    description: "random color generator with javascript",
    address: "https://random-color-generator-lime.vercel.app/",
    code: "https://github.com/kebele/random_color_generator",
  },
  {
    title: "notes with voice",
    image: require("../assets/images/vue-voice.png"),
    category: "all vue",
    description: "vue.js ile ses ile not alma",
    address: "https://voice-recog-notes.vercel.app/",
    code: "https://www.youtube.com/watch?v=Mxx_LY747Aw",
  },
  {
    title: "circular menu",
    image: require("../assets/images/circmenu.png"),
    category: "all html-css",
    description: "responsive website UI",
    address: "https://circular-nav.vercel.app/#",
    code: "https://github.com/kebele/circular-nav",
  },
  {
    title: "flying text",
    image: require("../assets/images/flytext.png"),
    category: "all html-css",
    description: "flying text with css",
    address: "https://flying-text.vercel.app/",
    code: "https://github.com/kebele/flying_text",
  },
  {
    title: "fish game",
    image: require("../assets/images/bubble catch.png"),
    category: "all javascript",
    description: "balık ile baloncuk yakalama oyunu",
    address: "https://bubble-catch.vercel.app/",
    code: "https://github.com/kebele/bubble_catch",
  },
  {
    title: "live ship",
    image: require("../assets/images/live_ship.png"),
    category: "all javascript",
    description: "live ship from all around the world",
    address: "https://live-ships.vercel.app/",
    code: "https://github.com/kebele/live_ships",
  },
  {
    title: "vue exercise tracker",
    image: require("../assets/images/exercise-tracker.png"),
    category: "all vue",
    description: "vue.js ile egzersiz takip uyguaması",
    address: "https://vue-exercise-tracker.vercel.app/",
    code: "https://github.com/kebele/vue-sport-tracker",
  },
  {
    title: "Kickstarter Projects",
    image: require("../assets/images/kickstarter.png"),
    category: "all other",
    description: "D3js ile kickstart projeleri",
    address: "https://treemap-d3.vercel.app/",
    code: "https://github.com/kebele/treemap_D3",
  },
  {
    title: "swiper cube",
    description: "swiper cube via css",
    image: require("../assets/images/swicube.png"),
    category: "all html-css",
    address: "https://swiper-cube.vercel.app/",
    code: "https://github.com/kebele/swiper_cube",
  },
  {
    title: "simple note",
    description: "note taking app",
    image: require("../assets/images/simplenote.png"),
    category: "all react",
    address: "https://simple-notes-ten.vercel.app/",
    code: "https://github.com/kebele",
  },
  {
    title: "asteroids game",
    image: require("../assets/images/asteroids.png"),
    category: "all other",
    description: "p5js ile asteroids oyunu",
    address: "https://asteroids-blush.vercel.app/",
    code: "https://github.com/kebele/asteroids",
  },
  {
    title: "animated eyes",
    image: require("../assets/images/animeeyes.png"),
    category: "all javascript",
    description: "animated eyes using javascript",
    address: "https://animated-eyes.vercel.app/",
    code: "https://github.com/kebele/animated-eyes",
  },
  {
    title: "vue anime search",
    description: "anime api ile search",
    image: require("../assets/images/vue-anime.png"),
    category: "all vue",
    address: "https://vue-anime-search.vercel.app/",
    code: "https://github.com/kebele/vue_anime_search",
  },
  {
    title: "movie site (UI)",
    description: "Movie site about marvel char with Vue.js",
    image: require("../assets/images/vuemovie.png"),
    category: "all vue",
    address: "https://vue-movie-web.vercel.app/",
    code: "https://github.com/kebele/html-marvel-web/",
  },
  {
    title: "voice note",
    description: "A note taking with voice.",
    image: require("../assets/images/voicenotes.png"),
    category: "all react",
    address: "https://r-speak-to-note.vercel.app/",
    code: "https://github.com/kebele",
  },

  {
    title: "tower defense",
    image: require("../assets/images/tower-defense.png"),
    category: "all javascript",
    description: "tower defense",
    address: "https://tower-defense-five.vercel.app/",
    code: "https://github.com/kebele/tower-defense",
  },
  {
    title: "todo app",
    description: "vue.js ile todo app",
    image: require("../assets/images/vue-todo.png"),
    category: "all vue",
    address: "https://vue-todo-sigma.vercel.app/#/",
    code: "https://github.com/kebele/vue_todo",
  },
  {
    title: "USA education attainment",
    image: require("../assets/images/usa-edu.png"),
    category: "all other",
    description: "D3js ile ABD mezuniyet haritası",
    address: "https://choropleth-map.vercel.app/",
    code: "https://github.com/kebele/choropleth_map",
  },
  {
    title: "movie app",
    description: "movie search app with vue",
    image: require("../assets/images/vue-movie.png"),
    category: "all vue",
    address: "https://vue-movie-kebele.vercel.app/",
    code: "https://github.com/kebele/vue_movie",
  },
  {
    title: "simple kanban board",
    image: require("../assets/images/vuesimplekanban.png"),
    category: "all vue",
    description: "simple kanbanr board with vue",
    address: "https://vuesimplekanban.vercel.app/",
    code: "https://github.com/kebele",
  },
  {
    title: "social media icons",
    image: require("../assets/images/3dsocial.png"),
    category: "all html-css",
    description: "3d social media icons",
    address: "https://3d-social-meda-icons-with-hover.vercel.app/",
    code: "https://github.com/kebele/3d-social-meda-icons-with-hover",
  },
  {
    title: "analog clock",
    image: require("../assets/images/anaclock.png"),
    category: "all javascript",
    description: "analog clock made with javascript",
    address: "https://analog-clock2.vercel.app/",
    code: "https://github.com/kebele/analog_clock2",
  },
  {
    title: "vue quiz",
    image: require("../assets/images/vue-quiz.png"),
    category: "all vue",
    description: "vue.js ile quiz uygulaması",
    address: "https://vue-quiz-pi.vercel.app/",
    code: "https://github.com/kebele/asteroids",
  },
  {
    title: "budget app",
    description: "expense and income tracking",
    image: require("../assets/images/rudget.png"),
    category: "all react",
    address: "https://r-budget.vercel.app/",
    code: "https://github.com/kebele/r-udget",
  },
  {
    title: "hangman game",
    description: "hangman game made by vue",
    image: require("../assets/images/vuehangman.png"),
    category: "all vue",
    address: "https://vuehangman.vercel.app/",
    code: "https://github.com/kebele/v-hangman",
  },
  {
    title: "flipcard",
    image: require("../assets/images/flipcard.png"),
    category: "all html-css",
    description: "flip card gallery",
    address: "https://flip-card-3.vercel.app/",
    code: "https://github.com/kebele/flip_card_3",
  },
  {
    title: "isometric 3d menu",
    description: "isometric menu via css",
    image: require("../assets/images/isometric_menu.png"),
    category: "all html-css",
    address: "https://isometric-3d-menu.vercel.app/",
    code: "https://github.com/kebele",
  },
  {
    title: "calculator",
    description: "react.js ile hesap makinesi",
    image: require("../assets/images/react-calc.png"),
    category: "all react",
    address: "https://calc-react-three.vercel.app/",
    code: "https://github.com/kebele/calc_react",
  },
  {
    title: "expense tracker",
    image: require("../assets/images/js-expense.png"),
    category: "all javascript",
    description: "javascript ile harcama takibi",
    address: "https://kebelebudget.netlify.app/",
    code: "https://github.com/kebele/budget",
  },
  {
    title: "falling leaves",
    image: require("../assets/images/leaves.png"),
    category: "all javascript",
    description: "fallen leaves with javascript",
    address: "https://leaves-one.vercel.app/",
    code: "https://github.com/kebele/leaves",
  },
  {
    title: "music player",
    image: require("../assets/images/js-music.png"),
    category: "all javascript",
    description: "javascript ile müzik player",
    address: "https://kebelemusicplayer.netlify.app/",
    code: "https://github.com/kebele/music_player",
  },
  {
    title: "responsive card",
    description: "responsive blury card via css",
    image: require("../assets/images/resp_card_css.png"),
    category: "all html-css",
    address: "https://responsive-card-eight.vercel.app/",
    code: "https://github.com/kebele/responsive_card",
  },
  {
    title: "vue weather",
    description: "Weather api ile hava durumu",
    image: require("../assets/images/vue-weather.png"),
    category: "all vue",
    address: "https://vuehava.netlify.app/",
    code: "https://github.com/kebele/vue-weather",
  },

  {
    title: "paint",
    image: require("../assets/images/js-paint.png"),
    category: "all javascript",
    description: "javascript ile paint",
    address: "https://paintykebele.netlify.app/",
    code: "https://github.com/kebele/painty",
  },
  {
    title: "plane war",
    image: require("../assets/images/js-planewar.png"),
    category: "all other",
    description: "P5js ile ucak savaşı",
    address: "https://plane-war.vercel.app/",
    code: "https://github.com/kebele/plane_war",
  },
  {
    title: "chart examples",
    description: "chart examples",
    image: require("../assets/images/chartexamp.png"),
    category: "all react",
    address: "https://r-chart.vercel.app/",
    code: "https://github.com/kebele",
  },

  {
    title: "translator",
    description: "multi language translator",
    image: require("../assets/images/translator.png"),
    category: "all react",
    address: "https://r-translator.vercel.app/",
    code: "https://github.com/kebele",
  },
  {
    title: "text to speech",
    image: require("../assets/images/text-to-speech.png"),
    category: "all javascript",
    description: "javascript ile text'ten sese",
    address: "https://text-to-speech-two.vercel.app/",
    code: "https://github.com/kebele/text-to-speech",
  },
  {
    title: "countdown",
    description: "countdown text via css",
    image: require("../assets/images/coundown_css.png"),
    category: "all html-css",
    address: "https://countdown-omega-lyart.vercel.app/",
    code: "https://github.com/kebele/countdown",
  },
  {
    title: "checkbox",
    description: "checkbox via css",
    image: require("../assets/images/checkbox2.png"),
    category: "all html-css",
    address: "https://checkbox-gamma.vercel.app/",
    code: "https://github.com/kebele/checkbox",
  },
  {
    title: "dropdown menu",
    description: "dropdown menu via css",
    image: require("../assets/images/drop_menu.png"),
    category: "all html-css",
    address: "https://drop-profile.vercel.app/",
    code: "https://github.com/kebele",
  },
  {
    title: "video player",
    image: require("../assets/images/video-player.png"),
    category: "all javascript",
    description: "video player",
    address: "https://kebelevideoplayer.netlify.app/",
    code: "https://github.com/kebele/video_player",
  },
  {
    title: "bottom navigation bar",
    description: "naviation bar with html-css",
    image: require("../assets/images/bottom-nav.png"),
    category: "all html-css",
    address: "https://bottom-nav-ivory.vercel.app/#",
    code: "https://github.com/kebele/bottom-nav",
  },
  {
    title: "shadow generator",
    description: "css shadow generator",
    image: require("../assets/images/shadowgen.png"),
    category: "all react",
    address: "https://r-shadow-gen.vercel.app/",
    code: "https://github.com/kebele",
  },
  {
    title: "text generator",
    description: "html text generator",
    image: require("../assets/images/textgen.png"),
    category: "all react",
    address: "https://r-text-gen.vercel.app/",
    code: "https://github.com/kebele",
  },
  {
    title: "profile card",
    description: "profile with clipart via css",
    image: require("../assets/images/profile_css.png"),
    category: "all html-css",
    address: "https://profile-clipart.vercel.app/",
    code: "https://github.com/kebele/profile_clipart",
  },
  {
    title: "glowing circle",
    description: "glowing circle via css",
    image: require("../assets/images/glowing.png"),
    category: "all html-css",
    address: "https://glowing-circle.vercel.app/",
    code: "https://github.com/kebele/glowing_circle",
  },
  {
    title: "tetris",
    image: require("../assets/images/js-tetris.png"),
    category: "all javascript",
    description: "biraz farklı bir tetris",
    address: "https://tetris-ten.vercel.app/",
    code: "https://github.com/kebele/tetris",
  },

  {
    title: "angry birds",
    image: require("../assets/images/angry-birds.png"),
    category: "all other",
    description: "P5js ile basit bir angry birds",
    address: "https://basic-angry-birds.vercel.app/",
    code: "https://github.com/kebele/basic-angry-birds",
  },
  {
    title: "video gallery ",
    image: require("../assets/images/vue-video.png"),
    category: "all vue",
    description: "a video gallery app with Vue.js",
    address: "https://vue-video-gallery.vercel.app/",
    code: "https://github.com/kebele/vue-video-gallery",
  },
  {
    title: "sling ball game",
    image: require("../assets/images/sling-ball.png"),
    category: "all javascript",
    description: "matter.js ile sling ball oyunu",
    address: "https://matterjs-deneme.vercel.app/",
    code: "https://github.com/kebele/matterjs_deneme",
  },
  {
    title: "simple table",
    description: "simple table with CRUD func.",
    image: require("../assets/images/simpletable.png"),
    category: "all react",
    address: "https://r-table.vercel.app/",
    code: "https://github.com/kebele",
  },

  {
    title: "proggress bar",
    description: "a proggres bar with html-css",
    image: require("../assets/images/progress-bar.png"),
    category: "all html-css",
    address: "https://about-progress.vercel.app/progress.html",
    code: "https://github.com/kebele/about_progress",
  },
  {
    title: "Doping in Pro-bicycle",
    image: require("../assets/images/doping.png"),
    category: "all other",
    description: "Doping issues in bicycle sport with D3.js",
    address: "https://doping-in-bicycle-sport.vercel.app/",
    code: "https://github.com/kebele/doping-in-bicycle-sport",
  },
  {
    title: "image to text",
    description: "image to text converter",
    image: require("../assets/images/imgtotext.png"),
    category: "all react",
    address: "https://image-to-text-liart.vercel.app/",
    code: "https://github.com/kebele",
  },
  {
    title: "random quote",
    description: "random quote generator with React.js",
    image: require("../assets/images/random-quote.png"),
    category: "all react",
    address: "https://random-quote-ivory.vercel.app/",
    code: "https://github.com/kebele/machine-for-random-quote",
  },
  {
    title: "calculator",
    description: "calculator with Vue.js",
    image: require("../assets/images/vue-calc.png"),
    category: "all vue",
    address: "https://vue-calculator-eight.vercel.app/",
    code: "https://github.com/kebele/vue_calculator",
  },
  {
    title: "random user",
    description: "random user generator",
    image: require("../assets/images/randomuser.png"),
    category: "all react",
    address: "https://r-random-user.vercel.app/",
    code: "https://github.com/kebele",
  },

  {
    title: "css tabs",
    image: require("../assets/images/css-tabs.png"),
    category: "all html-css",
    description: "css tabs",
    address: "https://tabs-css.vercel.app/",
    code: "https://github.com/kebele/tabs_css",
  },
  {
    title: "mobile tabs",
    image: require("../assets/images/mobile-tabs.png"),
    category: "all html-css",
    description: "mobile tabs arayüz örneği",
    address: "https://mobile-tabs.vercel.app/",
    code: "https://github.com/kebele/mobile-tabs",
  },
  {
    title: "four dots",
    image: require("../assets/images/4-dots.png"),
    category: "all html-css",
    description: "loading örneği",
    address: "https://4-dots.vercel.app/",
    code: "https://github.com/kebele/4_dots",
  },
  {
    title: "breaking bad",
    image: require("../assets/images/breaking.png"),
    category: "all react",
    description: "breaking bad oyuncu bilgileri",
    address: "https://build-pi-one.vercel.app/",
    code: "https://github.com/kebele/4_dots",
  },

  {
    title: "rotating earth",
    image: require("../assets/images/earth-rotating.png"),
    category: "all html-css",
    description: "rotating earth",
    address: "https://earth-rotating-with-plane-git-main.kebele.vercel.app/",
    code: "https://github.com/kebele/earth-rotating-with-plane",
  },
  {
    title: "product card",
    image: require("../assets/images/productcard.png"),
    category: "all html-css",
    description: "product card",
    address: "https://product-card-eosin.vercel.app/",
    code: "https://github.com/kebele/product-card",
  },
  {
    title: "zooming effect",
    image: require("../assets/images/zooming.png"),
    category: "all html-css",
    description: "zooming effect with mouse",
    address: "https://image-hover-zoom.vercel.app/",
    code: "https://github.com/kebele/image-hover-zoom",
  },
  {
    title: "scratch effect",
    image: require("../assets/images/scratcheffect.png"),
    category: "all html-css",
    description: "scratch effect with mouse",
    address: "https://scratch-effect.vercel.app/",
    code: "https://github.com/kebele/scratch-effect",
  },
  {
    title: "particles",
    image: require("../assets/images/particles.png"),
    category: "all html-css",
    description: "particles effect using mouse",
    address: "https://css-particles.vercel.app/",
    code: "https://github.com/kebele/css-particles",
  },
  {
    title: "note paper",
    image: require("../assets/images/notepaper.png"),
    category: "all html-css",
    description: "notebook paper made with css",
    address: "https://note-paper.vercel.app/",
    code: "https://github.com/kebele/note_paper",
  },

  {
    title: "vue anime quoter",
    image: require("../assets/images/vue-anime-quoter.png"),
    category: "all vue",
    description: "vue.js ile anime çizgi filmlerdeki replikler",
    address: "https://vue-anime-quoter.vercel.app/",
    code: "https://github.com/kebele/asteroids",
  },

  // {
  //   title: "vue notes with voice",
  //   image: require("../assets/images/vue-voice.png"),
  //   category: "all vue",
  //   description: "vue.js ile ses ile not alma",
  //   address: "https://voice-recog-notes.vercel.app/",
  //   code: "#portfolio",
  // },
];

export default projects;
